import { Injectable } from "@angular/core";
import { EntityStoreService } from "../../../../shared/store/entity-store/entity-store.service";
import {
  EntityMetadata,
  EntityStoreState,
} from "../../../../shared/store/store-types.model";
import { LotMouvement } from "../../models/lot.model";
import { MouvementFacadeService } from "./mouvement-facade.service";

@Injectable({ providedIn: "root" })
export class MouvementStoreService extends EntityStoreService<
  LotMouvement,
  EntityMetadata,
  LotMouvementState
> {
  constructor() {
    super({
      ...EntityStoreService.initialState,
    });
  }
}

export interface LotMouvementState
  extends EntityStoreState<MouvementFacadeService> {}
